import { useWalletView } from '#/features/wallet/wallet-context';

import { Error } from '#/components/common/alert';

import WalletConnectModal from './WalletConnectModal';
import WalletConnectButton from './WalletConnectButton';
import LegalDisclaimer from './LegalDisclaimer';
import { Modal, ModalCloseButton, ModalHeader, ModalTitle } from './Modal';

interface Props {
  readonly isOpen: boolean;
  readonly closeModal: () => void;
}

export default function WalletModalConnect(props: Props) {
  const { isOpen, closeModal } = props;

  const walletView = useWalletView();

  // Prevents loading WalletConnect assets until the modal is opened.
  if (!isOpen) return;

  return (
    <>
      <Modal isOpen={isOpen} onDismiss={closeModal}>
        <ModalHeader>
          <ModalTitle>Connect your Wallet</ModalTitle>
          {walletView.status === 'idle' && (
            <ModalCloseButton onClick={closeModal} />
          )}
        </ModalHeader>
        <LegalDisclaimer />
        <WalletConnectButton />
        {walletView.error.length > 0 && <Error>{walletView.error}</Error>}
      </Modal>
      <WalletConnectModal />
    </>
  );
}
